import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import { useQuery } from 'react-query';

// configs
import { API } from 'configs/api';
// keys
import { conversationsQueryKeys } from './conversationsQueryKeys';
// types
import { ISingleConversation } from './types';
import { getShortUrlFromUrl } from 'utils/url';

export const fetchConversations = async (chatId: string | undefined) => {
  const shortUrl = getShortUrlFromUrl();
  const response: AxiosResponse<ISingleConversation> = await API.get<
    ISingleConversation
  >(`/playback/${shortUrl}/conversations/${chatId}`, {
    params: { from: dayjs().format('YYYY-MM-DD') },
  });

  return response.data;
};

export const useConversationsQuery = (chatId: string | undefined) => {
  return useQuery<ISingleConversation, Error>(
    [...conversationsQueryKeys.all(), chatId],
    () => fetchConversations(chatId),
    {
      onError: () => {
        console.log(`error loading conversation ${chatId}`);
      },
    }
  );
};
